import * as React from 'react';
import SpecialOfferForm from "../../components/SpecialOffers/SpecialOfferForm/SpecialOfferForm";
var SpecialOffer = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u043D\u0430 \u043E\u0444\u0435\u0440\u0442\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(SpecialOfferForm, null))))));
};
export default SpecialOffer;



//////////////////
// WEBPACK FOOTER
// ./src/views/SpecialOffers/SpecialOffer.tsx
// module id = 467
// module chunks = 0